import { render } from "./course-header.vue?vue&type=template&id=6ce16490"
import script from "./course-header.vue?vue&type=script&lang=js"
export * from "./course-header.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__